export default __webpack_public_path__ + "static/media/overwatch_banner.59dae802.png";